/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the landing page to the DOM.
 *
 * It is included in `src/index.html`.
 */

import "./fonts/inter";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RevenueLandingPage } from "./revenue/RevenueLandingPage";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <RevenueLandingPage />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
